import { useTranslation } from 'react-i18next';
import { TruckIcon, ClockIcon } from '@heroicons/react/24/outline';

export type FulfillmentMethod = 'delivery' | 'pickup' | null;

interface FullfillmentMethodsProps {
  onSelect: (option: FulfillmentMethod) => void;
  selectedOption: 'delivery' | 'pickup' | null;
}

function FullfillmentMethods({ onSelect, selectedOption }: FullfillmentMethodsProps) {
  const { t } = useTranslation();

  return (
    <div className='border-b border-gray-200 pb-6 mb-4'>
      <h2 className='text-lg font-medium text-black mb-4'>{t('checkout.fulfillmentMethod.choose')}</h2>
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
        <button
          type='button'
          onClick={() => onSelect('delivery')}
          className={`relative flex items-center p-4 rounded-xl border shadow-sm focus:outline-none transition-all duration-200 ease-in-out cursor-pointer text-start ${selectedOption === 'delivery'
            ? 'border-primary ring-2 ring-primary ring-offset-2 bg-primary/5'
            : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-md'
            }`}
          aria-pressed={selectedOption === 'delivery'}
        >
          <div className='flex items-center w-full gap-3'>
            <TruckIcon className={`h-6 w-6 flex-shrink-0 ${selectedOption === 'delivery' ? 'text-primary' : 'text-gray-500'}`} />
            <div>
              <div className='font-medium text-gray-900'>{t('checkout.fulfillmentMethod.delivery')}</div>
              <div className='text-sm text-gray-500 mt-1'>{t('checkout.fulfillmentMethod.deliveryDescription')}</div>
            </div>
          </div>
        </button>

        <button
          type='button'
          onClick={() => onSelect('pickup')}
          className={`relative flex items-center p-4 rounded-xl border shadow-sm focus:outline-none transition-all duration-200 ease-in-out cursor-pointer text-start ${selectedOption === 'pickup'
            ? 'border-primary ring-2 ring-primary ring-offset-2 bg-primary/5'
            : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-md'
            }`}
          aria-pressed={selectedOption === 'pickup'}
        >
          <div className='flex items-center w-full gap-3'>
            <ClockIcon className={`h-6 w-6 flex-shrink-0 ${selectedOption === 'pickup' ? 'text-primary' : 'text-gray-500'}`} />
            <div>
              <div className='font-medium text-gray-900'>{t('checkout.fulfillmentMethod.pickup')}</div>
              <div className='text-sm text-gray-500 mt-1'>{t('checkout.fulfillmentMethod.pickupDescription')}</div>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
}

export default FullfillmentMethods;
